import { reducers } from 'redux/core'
import request from 'sb-request'
import { getGqlQuery } from 'common/helpers'


const fetch = ({ gender, count, collectionType }) => {
  reducers.models.collections.setCollections([])
  reducers.models.collections.setFetching(true)

  request.post('graphql?name=collections', {
    body: {
      query: `{
        ${getGqlQuery('collections', { count, gender, collectionType })} {
          id
          url
          image
          title
          gender
          imgMobile
          imgDesktop
          appearance
          description
        }
      }`,
    },
  })
    .then(
      ({ collections = [] }) => {
        reducers.models.collections.setCollections(collections)

        return collections
      },
      () => {
        reducers.models.collections.setFetching(false)
        return Promise.reject()
      }
    )
}


export default {
  fetch,
}
